import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type ActorStatus,
  patchActorsActorIDStatus,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTORS_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdateActorStatusParams {
  actorID: string;
  status: ActorStatus;
}

export function useUpdateActorStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ actorID, status }: UpdateActorStatusParams) =>
      patchActorsActorIDStatus({ status }, actorID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { actorID }) => {
      queryClient.invalidateQueries({ queryKey: ACTORS_QUERY_KEYS.all });
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.detail(actorID),
      });
    },
  });
}
